const state = {
    TextUwelcome: "",
    TextNewUser:"",
    TextUeberlassung:"",
    Education: {
        allEdu: [],
        myEdu: []
    },
    Weapons:[],
    DisziWeapon:[],
    Clubs:[],
    Selected_ShootingRanges:[],
    MyShootingbook:[],
    Shootingbook_Entry_Signature:[],
    OpenShootingBookEntry: [],
    OpenShootingBookData:[],
    Discipline:[],
    DisziSingleWeapon:[],
    ShootingRangeFreeplaces:[],
    WaffGCompliance:[],
    Dashboard: {
        WeaponsCount: '',
        WeaponsTransferCount: '',
        WeaponsMyTransferCount: '',
        SBCount: '',
        SBOpenCount: '',
        SBLastEntry: [],
        WeeklyShootingCount: []
    },
    Charts:null,
    shootingbook_Count:null,
    shootingbook_sign_error: false,
    shootingbook_loader: false,
    recordshootingTime_show_freeplaces: false,
    recordshootingTime_show_freeplaces_loader: false,
    WeaponPool: [],
    // Pool des Hauptvereins für externe Einträge (getrennt von WeaponPool der internen Maske)
    WeaponPoolHauptverein: [],
    MyPoolContributions: [],
    PoolFilters: {
        kaliber: null,
        gattung: null,
        discipline_id: null,
        beduerfnis: null
    },
    BeduerfnisOptions: [],
    SchiessleiterToday: [],
    // Arbeitsstunden
    ArbeitsstundenFunctions: [],
    Arbeitseinsaetze: [],
    WorkingHours: []
};

export default state;
